import src from "IMAGE";
export default { src, width: 47, height: 50, blurWidth: 0, blurHeight: 0};
